<template>
  <v-container fluid>
  <section>
    <!-- Summary Cards (4 Cards) -->
    <KpiCards class="mb-3" :items="kpiItems" :loading="loadingSummary" :skeleton="4" />

    <data-table
      :headers="headers"
      :items="suppliers"
      commit="SET_SUPPLIERS"
      :viewItem="viewItem"
      :editItem="editItem"
      :deleteItem="deleteItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">{{ $t("supplier") }} </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-5">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 text-end">
          <v-btn
            depressed
            color="primary"
            class="white--text btn-primary-brand"
            @click="newItem"
          >
            <v-icon left small>fal fa-plus</v-icon>
            {{ $t("new_data") }}
          </v-btn>
        </div>
      </div>
    </data-table>
    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      title="description"
      @submit="submitForm"
    >
      <div slot="activator">
        <v-row>
          <v-col cols="4">{{ $t("id") }}</v-col>
          <v-col cols="8">{{ form.id }}</v-col>
          <v-col cols="4">{{ $t("name") }}</v-col>
          <v-col cols="8">{{ form.name }}</v-col>
          <v-col cols="4">{{ $t("address") }}</v-col>
          <v-col cols="8">{{ form.address }}</v-col>
          <v-col cols="4">{{ $t("phone_no") }}</v-col>
          <v-col cols="8">{{ form.phone_no }}</v-col>

          <v-col cols="4">{{ $t("contact_name") }}</v-col>
          <v-col cols="8">{{ form.contact_name }}</v-col>
          <v-col cols="4">{{ $t("contact_phone") }}</v-col>
          <v-col cols="8">{{ form.contact_no }}</v-col>

          <v-col cols="4">{{ $t("stock_histories_count") }}</v-col>
          <v-col cols="8">{{
            form.stock_histories_count | NumberFormat
          }}</v-col>
          <v-col cols="4">{{ $t("date") }}</v-col>
          <v-col cols="8">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
    <app-custom-dialog
      v-model="dialogAdd"
      :footer="true"
      :title="titleStatus"
      :submit-text="update ? 'save' : 'add'"
      :submit-loading="submitting"
      @submit="submitForm"
    >
      <div slot="activator">
        <TTextField
          label="name"
          v-model="form.name"
          :errorMessages="nameErrors"
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        />
        <TTextField
          class="mt-3"
          label="address"
          v-model="form.address"
          :errorMessages="addressErrors"
          @input="$v.form.address.$touch()"
          @blur="$v.form.address.$touch()"
        />
        <TTextField
          class="mt-3"
          label="phone_no"
          v-model="form.phone_no"
          :errorMessages="phone_noErrors"
          @input="$v.form.phone_no.$touch()"
          @blur="$v.form.phone_no.$touch()"
          :maxlength="10"
        />
        <TTextField
          class="mt-3"
          label="contact_name"
          v-model="form.contact_name"
          :maxlength="255"
        />
        <TTextField
          class="mt-3"
          label="contact_phone"
          v-model="form.contact_no"
          :maxlength="20"
        />
      </div>
    </app-custom-dialog>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { vendorHead } from "@/utils/head";
import { myMixin } from "@/mixin/main";
import TTextField from "@/components/global/TextField";
import { success, confirm, toast } from "@/controllers/alert";
import { VENDOR } from "@/validations/shop";

const defaultSupplierForm = () => ({
  name: "",
  address: "",
  phone_no: "",
  contact_name: "",
  contact_no: "",
});

export default {
  mixins: [VENDOR, myMixin],
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    overlay: false,
    submitting: false,
    search: "",
    loadingSummary: true,
    summaries: [],

    form: defaultSupplierForm(),
  }),

  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary()]);
  },
  components: { DataTable, TTextField },
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      suppliers: "index/suppliers",
    }),

    titleStatus() {
      return this.update ? "update" : "new_data";
    },
    headers() {
      return vendorHead(this);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const body = {
        that: this,
        url: `suppliers_paginate?q=${this.search}`,
        commit: "SET_SUPPLIERS",
      };
      await this.fetch(body);
    },

    async fetchSummary() {
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get("get_summary_suppliers");
        if (data && data.status) {
          this.summaries = data.data;
        }
      } catch (error) {
        console.log("error fetching supplier summary", error);
      } finally {
        this.loadingSummary = false;
      }
    },

    newItem() {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.form = defaultSupplierForm();
      this.update = false;
      this.dialogAdd = true;
    },
    editItem(item) {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.update = true;
      this.form = {
        ...defaultSupplierForm(),
        ...item,
      };
      this.dialogAdd = true;
    },
    async deleteItem({ products_count, id }) {
      if (products_count > 0) {
        toast(this, "contain_product", "error");
        return;
      }
      const { isConfirmed } = await confirm({
        props: this,
        text: "want_to_delete",
      });
      if (isConfirmed) {
        try {
          const { data } = await this.$http.delete(`suppliers/${id}`);
          if (data && data.status) {
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } catch (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            this.$t("error_occurred") ||
            "Error";
          if (this.$toast) {
            this.$toast.error(message);
          } else {
            await toast(this, message, "error");
          }
        }
      }
    },
    viewItem(item) {
      this.form = {
        ...defaultSupplierForm(),
        ...item,
      };
      this.dialog = true;
    },
    async submitForm() {
      try {
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
          return;
        }

        this.submitting = true;
        if (this.update) {
          const { data } = await this.$http.put(
            `suppliers/${this.form.id}`,
            this.form
          );
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } else {
          const { data } = await this.$http.post("suppliers", this.form);
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        }
      } catch (error) {
        console.error("error submitting supplier", error);
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) {
          this.$toast.error(message);
        } else {
          await toast(this, message, "error");
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
